module.exports = __webpack_public_path__ + "img/successful3.93bbcfc2.png";